(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function init() {
    const headerWrapper = document.querySelector('.header-wrapper--transparent-product');
    const mediaWrapper = document.querySelector('.product__media-wrapper') || document.querySelector('main')?.firstElementChild;
    if (!headerWrapper || !mediaWrapper) return;

    if (!mobileQuery.matches) {
      headerWrapper.classList.remove('is-scrolled');
      return;
    }

    const threshold = Math.max(0, mediaWrapper.offsetHeight * 0.7);

    function onScroll() {
      const scrolled = (window.pageYOffset || document.documentElement.scrollTop) > threshold;
      headerWrapper.classList.toggle('is-scrolled', scrolled);
    }

    onScroll();
    document.addEventListener('scroll', onScroll, { passive: true });
  }

  function bindMenuDrawerToggle() {
    const headerWrapper = document.querySelector('.header-wrapper--transparent-product');
    const menuDetails = document.getElementById('Details-menu-drawer-container');
    if (!headerWrapper || !menuDetails || menuDetails.dataset.transparentHeaderBound) return;
    menuDetails.dataset.transparentHeaderBound = 'true';
    menuDetails.addEventListener('toggle', function () {
      headerWrapper.classList.toggle('menu-open', menuDetails.open);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('DOMContentLoaded', bindMenuDrawerToggle);
  mobileQuery.addEventListener('change', init);
  window.addEventListener('resize', init);
})();
